
// Auto-pause other videos when one starts playing
(function() {
    'use strict';
    
    // Store currently playing video
    let currentlyPlaying = null;
    
    // Function to pause all videos except the current one
    function pauseOtherVideos(currentVideo) {
        const allVideos = document.getElementsByTagName('video');
        
        for (let video of allVideos) {
            if (video !== currentVideo && !video.paused) {
                video.pause();
            }
        }
    }
    
    // Function to add event listeners to a video element
    function addVideoListeners(video) {
        // Remove existing listeners to prevent duplicates
        video.removeEventListener('play', handleVideoPlay);
        
        // Add play event listener
        video.addEventListener('play', handleVideoPlay);
    }
    
    // Handle video play event
    function handleVideoPlay(e) {
        const playingVideo = e.target;
        
        // If this is a different video than currently playing
        if (currentlyPlaying !== playingVideo) {
            pauseOtherVideos(playingVideo);
            currentlyPlaying = playingVideo;
        }
        
        // Add pause listener to clear current reference
        playingVideo.addEventListener('pause', function() {
            if (currentlyPlaying === playingVideo) {
                currentlyPlaying = null;
            }
        }, { once: true });
    }
    
    // Initialize existing videos
    function initializeExistingVideos() {
        const existingVideos = document.getElementsByTagName('video');
        for (let video of existingVideos) {
            addVideoListeners(video);
        }
    }
    
    // Watch for dynamically added videos
    function observeNewVideos() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if the added node is a video
                        if (node.tagName === 'VIDEO') {
                            addVideoListeners(node);
                        }
                        // Check for videos within the added node
                        const videos = node.getElementsByTagName ? node.getElementsByTagName('video') : [];
                        for (let video of videos) {
                            addVideoListeners(video);
                        }
                    }
                });
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        return observer;
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initializeExistingVideos();
            observeNewVideos();
        });
    } else {
        initializeExistingVideos();
        observeNewVideos();
    }
    
    // Optional: Add to window for manual control
    window.videoPauseController = {
        pauseAll: function() {
            const allVideos = document.getElementsByTagName('video');
            for (let video of allVideos) {
                if (!video.paused) {
                    video.pause();
                }
            }
            currentlyPlaying = null;
        },
        getCurrentlyPlaying: function() {
            return currentlyPlaying;
        }
    };
    
})();
// Video - Stop when not in view zone
document.addEventListener("DOMContentLoaded", function () {
    const mediaElements = document.querySelectorAll("video, audio");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const media = entry.target;
        if (!entry.isIntersecting && !media.paused) {
          media.pause();
        }
      });
    }, {
      threshold: 0.1
    });

    mediaElements.forEach(media => {
      observer.observe(media);
    });
  });


const backToTopBtn = document.querySelector('.back_to_top');

if (backToTopBtn) {
  backToTopBtn.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

$(document).on('click','.cancel_request-btn',function() {
    // var dataID = $(this).attr('data-order-name');
    // $('#ContactForm-orderID').val(dataID);
    $('body').addClass('open_model');
    $('.shopify-app-block').addClass('open_model-form');
    $('#shopify-section-template--18543684583522__1776245251a72a3133').addClass('open_model-form');
});
$(document).on('click', '.icon_close', function() {
    $('body').removeClass('open_model');
    $('.shopify-app-block').removeClass('open_model-form');
    $('#shopify-section-template--18543684583522__1776245251a72a3133').removeClass('open_model-form');
});

const sections = document.querySelectorAll(
  ".account #shopify-section-template--18543684583522__1776245251a72a3133"
);

sections.forEach(section => {
  const btn = document.createElement("button");
  btn.classList.add("close-modal");
  btn.innerHTML = "✖";

  const appBlock = section.querySelector(".shopify-app-block");
  
  if (appBlock) {
    appBlock.prepend(btn);
  }
});

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("close-modal")) {
    const modal = e.target.closest(
      "#shopify-section-template--18543684583522__1776245251a72a3133"
    );
    const modal2 = e.target.closest(".shopify-app-block");

    if (modal) {
      modal.classList.remove("open_model-form");
    }

    if (modal2) {
      modal2.classList.remove("open_model-form");
    }
  }
});

  document.addEventListener('DOMContentLoaded', () => {
    const mainContent = document.querySelector('.index main#MainContent');
    if (mainContent) {
      setTimeout(() => {
        mainContent.classList.add('remove-loading');
      }, 600);
    }
    // const track = document.querySelector('.announcement-carousel__track');
    // if (!track) return;
    // track.innerHTML += track.innerHTML; 
  });